import { ICategory, IPrompt } from '@/types'
import { State } from '.'
import { IList } from './modules/prompts'
import { Guest, User } from './modules/user'

export interface Getters {
    prompts: IList<IPrompt>,
    myPrompts: IPrompt[],
    favorites: IList<IPrompt>,
    promptsLoading: boolean,
    userLoading: Promise<any>,
    categories: ICategory[],
    user: User,
    guest: Guest,
    isAdmin: boolean,
    isModer: boolean,
}

export default {
    categories: (state: State) => state.categories.categories,
    prompts: (state: State) => state.prompts.prompts,
    myPrompts: (state: State) => state.prompts.myPrompts,
    favorites: (state: State) => state.prompts.favorites,
    promptsLoading: (state: State) => state.prompts.promptsLoading,
    userLoading: (state: State) => state.user.userLoading,
    user: (state: State) => state.user.user,
    guest: (state: State) => state.user.guest,
    isAdmin: (state: State) => state.user.user?.roles.includes("ADMIN"),
    isModer: (state: State) => state.user.user?.roles.includes("ADMIN") || state.user.user?.roles.includes("MODER"),
}
